export default __webpack_public_path__ + "static/media/05_DAIF_UseCase_02.7c1886dc.mp4";